import React from "react";
import SessionExpiredDialog from "../component/SessionExpiredDialog";


const SessionExpiredPage = () => {
    return (
        <SessionExpiredDialog/>
    );
}

export default SessionExpiredPage;
